export const POPUP_TEXT = {
  FINISH_COURSE: {
    value: 0,
    text: '完成课程',
  },
  JOIN_COURSE: {
    value: 1,
    text: '按时参加预约课程',
  },
  COMMENT_COURSE: {
    value: 2,
    text: '参与课程评价',
  },
  SHARE_POSTER: {
    value: 3,
    text: '分享海报',
  },
  SHARE_COURSE: {
    value: 4,
    text: '分享课程',
  },
}

export const CONSUME_TYPE = {
  FREE: {
    value: 0,
  },
  COIN: {
    value: 1,
  },
  DIAMOND: {
    value: 2,
  },
}

export const FORM_MODE_TYPE = {
  CREATE: 0,
  FILL: 1,
  SHOW_QUESTION: 2,
  SHOW_RESULT: 3,
}
export const COURSE_ENABLE = 1

export const FISCAL_TAX = 'fiscal-tax'
export const CCC = '3C'

export const COURSE_STATE = {
  DRAFT: 1,
  FORECAST: 2,
  LIVING: 3,
  ENDED: 4,
}
